module.exports = __webpack_public_path__ + "static/trophe-4acc103bc2cffd728c6304a0f7f58c91.svg";